import { useEffect } from 'react';
import Header from '../../../components/base/Header';
import Footer from '../../../components/base/Footer';
import { Link } from 'react-router-dom';

export default function OmikujiConceptBlog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-rose-50 to-orange-50">
      <Header />

      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-r from-pink-500 to-rose-500">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block mb-6">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i className="ri-gift-line text-5xl text-white"></i>
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              🌼 今日の"花言葉おみくじ"ってなに？
            </h1>
            <p className="text-xl text-white/90 mb-6">
              ──あなたの一日に、やさしい一輪を──
            </p>
            <div className="flex items-center justify-center gap-4 text-white/90">
              <span className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                2025年11月2日
              </span>
              <span className="flex items-center">
                <i className="ri-user-line mr-2"></i>
                ももちゃん
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/8ca6952e6a33257e04fb8ac67bcd75fe/775a1306757aaaabc608ab540981a1c8.jpeg"
                alt="花言葉おみくじ"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            {/* Introduction */}
            <div className="mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                こんにちは、モモちゃん畑のももちゃんです🌸<br />
                今日は、このサイトの人気コーナー？<br />
                「花言葉おみくじ」 のコンセプトを紹介したいと思います。
              </p>
            </div>

            {/* Section 1 */}
            <div className="mb-12 bg-gradient-to-br from-pink-50 to-rose-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-rose-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌸</span>
                おみくじを作った理由
              </h2>
              <h3 className="text-xl font-bold text-rose-700 mb-6">
                ──毎日に、小さな"やさしさの種"を
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  私自身、仕事や子育てでバタバタする日もあれば、<br />
                  なんとなく気持ちが落ちる日もあります。
                </p>
                <p>
                  そんなとき、<br />
                  たまたま目にした花の花言葉が<br />
                  びっくりするほど心に響いたことがありました。
                </p>
                <div className="bg-white rounded-2xl p-6 my-6 border-l-4 border-rose-400">
                  <p className="text-rose-700 font-medium">
                    「今日だけでも、この言葉に助けられたい」<br />
                    「誰かの1日が、ちょっと明るくなればいいな」
                  </p>
                </div>
                <p>
                  そんな想いから、この<br />
                  "今日の花言葉おみくじ" を作りました。
                </p>
                <p className="font-medium text-rose-800">
                  もちろん吉凶はありません。<br />
                  ただ心が軽くなる、小さな花のメッセージを受け取れる仕組みです。
                </p>
              </div>
            </div>

            {/* Section 2 */}
            <div className="mb-12 bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-green-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌱</span>
                花言葉の歴史って、どこから来たの？（軽い雑学）
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  花言葉の文化は、<br />
                  19世紀のヨーロッパで盛んになった<br />
                  "フラワー・ランゲージ（花の言葉）" が始まりと言われています。
                </p>
                <p>
                  当時は気持ちをストレートに伝えるのが難しく、<br />
                  恋人や家族に「言葉の代わり」として花を渡しました。
                </p>
                <div className="grid md:grid-cols-3 gap-4 my-6">
                  <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <div className="text-4xl mb-3">🌹</div>
                    <h3 className="text-lg font-bold text-red-600 mb-2">バラ</h3>
                    <p className="text-sm text-gray-600">情熱</p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <div className="text-4xl mb-3">🌼</div>
                    <h3 className="text-lg font-bold text-yellow-600 mb-2">スイセン</h3>
                    <p className="text-sm text-gray-600">自己愛</p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <div className="text-4xl mb-3">💜</div>
                    <h3 className="text-lg font-bold text-indigo-600 mb-2">スミレ</h3>
                    <p className="text-sm text-gray-600">誠実</p>
                  </div>
                </div>
                <p>
                  日本には明治時代に伝わり、<br />
                  独自の解釈とともに広がっていきました。
                </p>
                <p className="font-medium text-green-800">
                  つまり花言葉は、<br />
                  人が花に想いを重ねてきた"優しい文化" なんです。
                </p>
              </div>
            </div>

            {/* Section 3 */}
            <div className="mb-12 bg-gradient-to-br from-orange-50 to-amber-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-orange-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌼</span>
                吉凶ではなく「花のメッセージ」を届けたい理由
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  占いには「大吉・凶」があるけれど、<br />
                  モモちゃん畑のおみくじにはありません。
                </p>
                <p>
                  理由はシンプルで……<br />
                  <span className="font-bold text-orange-700">花に"良い・悪い"は存在しないから。</span>
                </p>
                <p>
                  花が咲くのに失敗も成功もなく、<br />
                  ただ静かに、誠実に、咲くタイミングを選んでいるだけ。
                </p>
                <div className="bg-white rounded-2xl p-8 my-6 text-center border-2 border-orange-200">
                  <p className="text-xl font-bold text-orange-800 mb-4">
                    だからこのおみくじは、
                  </p>
                  <p className="text-lg text-gray-700">
                    今日の気持ちにそっと寄り添う<br />
                    "花からのメッセージカード"
                  </p>
                </div>
                <p>
                  みたいな感覚で受け取ってほしいと思っています。
                </p>
                <div className="space-y-3 my-6">
                  <div className="flex items-start">
                    <span className="text-orange-500 mr-3 mt-1">✿</span>
                    <p>落ち込んだときは寄り添ってくれるし、</p>
                  </div>
                  <div className="flex items-start">
                    <span className="text-orange-500 mr-3 mt-1">✿</span>
                    <p>前向きなときは背中を押してくれる。</p>
                  </div>
                </div>
                <p className="font-medium text-orange-800">
                  あなたの"今"に合わせて響く言葉が届きます。
                </p>
              </div>
            </div>

            {/* Section 4 */}
            <div className="mb-12 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-teal-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌷</span>
                ももちゃんからの一言
              </h2>
              <h3 className="text-xl font-bold text-teal-700 mb-6">
                ──今日のあなたに、やさしい一輪を
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  花は、何も言わずに生きています。<br />
                  でも、心で見ると、たくさんのメッセージを届けてくれます。
                </p>
                <p>
                  このおみくじが、あなたの日常の中で<br />
                  「ちょっと一息つける瞬間」<br />
                  になれたらうれしいです。
                </p>
                <div className="bg-white rounded-2xl p-8 my-6 text-center border-2 border-teal-200">
                  <p className="text-2xl font-bold text-teal-800">
                    今日のあなたがどんな一日でも、<br />
                    花はいつだって味方です。
                  </p>
                </div>
                <p className="text-center text-lg font-medium text-teal-700">
                  それでは……<br />
                  今日の花言葉おみくじ、どうぞ引いてみてくださいね❁
                </p>
              </div>
            </div>

            {/* CTA to Omikuji */}
            <div className="mb-12 text-center">
              <Link
                to="/omikuji"
                className="inline-flex items-center bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-bold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-gift-line mr-2"></i>
                花言葉おみくじを引く
              </Link>
            </div>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 mb-12">
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #花言葉
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #おみくじ
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #コンセプト
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #日常
              </span>
            </div>

            {/* Back Button */}
            <div className="text-center">
              <Link
                to="/essay"
                className="inline-flex items-center bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-bold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                エッセイ一覧に戻る
              </Link>
            </div>
          </div>
        </div>
      </article>

      {/* Related Posts */}
      <section className="py-16 bg-gradient-to-br from-pink-50 to-rose-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-rose-800 mb-8 text-center">
              他のブログ記事も読む
            </h2>
            <div className="text-center">
              <Link
                to="/essay"
                className="inline-flex items-center text-rose-600 hover:text-rose-700 font-medium transition-colors"
              >
                すべての記事を見る
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
